import React from 'react';
import AuthScreen from '../../components/Auth/AuthScreen';
import AuthForm from '../../components/Auth/AuthForm';

const Register: React.FC = () => (
  <AuthScreen>
    <AuthForm defaultMode="signup" />
  </AuthScreen>
);

export default Register;
